module.exports = __webpack_public_path__ + "img/dippy.42d8205f.png";